import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from '../../types';
import SalesParameters from '../../components/SalesParameters';

import './index.scss';

const SellingInfoContainer: FC = () => {
  const purchase = useSelector(
    (state: RootState) => state.operationsSign.data.sale
  );

  return (
    <div className="selling-info__right-container">
      <div className="mb_32">
        <SalesParameters />
      </div>
      <div className="requisites">
        <p className="p p_bold p_color_grey mb_24">Реквизиты платежа:</p>

        <div className="requisites-container">
          <p className="p p_color_grey">
            {get(purchase, 'initiatorCompanyInfo.shortName', '')}
            <br />
            <br />
            ИНН / КПП: {get(purchase, 'initiatorCompanyInfo.tin', '') + " / " + get(purchase, 'initiatorCompanyInfo.kpp', '')}
            <br />
            ОГРН: {get(purchase, 'initiatorCompanyInfo.regNumber', '')}
            <br />
            Адрес: {get(purchase, 'initiatorCompanyInfo.address', '')}
            <br />
            <br />
            Р/С: {get(purchase, 'agentBankAccount.accountNumber', '')}
            <br />
            Банк: {get(purchase, 'agentBankAccount.bankName', '')}
            <br />
            БИК: {get(purchase, 'agentBankAccount.bik', '')}
            <br />
            К/С: {get(purchase, 'agentBankAccount.corrAccountNumber', '')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SellingInfoContainer;
